import { render, staticRenderFns } from "./CategoryNode.vue?vue&type=template&id=eb84cea4&scoped=true"
import script from "./CategoryNode.vue?vue&type=script&lang=js"
export * from "./CategoryNode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb84cea4",
  null
  
)

export default component.exports